// extracted by mini-css-extract-plugin
module.exports = {"loadingText":"Loading_loadingText__2nKgp","dash":"Loading_dash__-_Le6","pulse":"Loading_pulse__3r1yx"};